import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ProjectForm from './ProjectForm';
import Header from './Header';
const CreateProject = ({ user, setUser }) => {
const navigate = useNavigate();
const projectId =   Date.now()

 useEffect(() => {
    // Redirect to "/" after logout
   if(!user) navigate('/');
  }, [navigate,user]);


    return (
          <div>
     <Header setUser={setUser} user={user} />  
            {projectId && (
                <ProjectForm projectId={projectId} user={user} />
            )}
        </div>
    );
};

export default CreateProject
